// @ts-nocheck

export const NAVBAR_BASE_HEIGHT = 3; // em
